import { z } from 'zod';

export const marketingPreferencesPostRequestSchema = z.object({ value: z.string() });
